import { breakpoints } from "@brightagency/headstart-common";
import styled from "styled-components";
import { colors } from "../../../utils/colors";
import { HeroTitle } from "../../atoms/HeroTitle";

export const Outer = styled.div`
    background-color: ${colors.brandMid};
`;

export const Inner = styled.div`
    position: relative;
    padding: 50px 0;

    ${breakpoints.large} {
        padding: 0;
        align-items: center;
        display: flex;
        height: 300px;
    }
`;

export const Title = styled(HeroTitle)`
    text-align: center;
    font-weight: bold;
    z-index: 1;
    position: relative;

    ${breakpoints.large} {
        width: 50%;
        text-align: left;
    }

    span{
        font-size: inherit;
        position: relative;
        display: inline;
        --underline-width-scale: calc(12 / 8);
        -webkit-box-decoration-break: clone;
        box-decoration-break: clone;
        background-repeat: no-repeat;
        background-image: linear-gradient(180deg, ${colors.brandDark}, ${colors.brandDark});
        background-position-x: calc(0 * var(--underline-width-scale)), 0, 100%;
        background-position-y: calc(90% - -2px * -1);
        background-size: calc(100% - calc(0px * var(--underline-width-scale) * 2)) 35%, auto calc(10 * 1px),auto calc(11 * 1px);
        padding-left: 5px;
        padding-right: 5px;
        left: -2px;
    }
`;

export const ImageWrapper = styled.div`
    position: relative;
    height: 100%;
    padding: 0;
    max-width: 400px;
    margin: 0 auto;

    ${breakpoints.large} {
        max-width: none;
        margin: 0;
        margin-left: 60px;
        width: 50%;
    }
`;

export const Image = styled.img`
    height: 100%;
    width: 100%;
    object-fit: contain;
`;

export const SaveWrapper = styled.div`
    position: absolute;
    bottom: 0;
    right: 0;
    transform: translateY(50%);
`;
